import { Actor, ActorsInfo } from './mini-dialog-types';

export type ActorAction =
  | { type: 'INITIALIZE_ACTORS'; payload: Actor[] }
  | { type: 'TOGGLE_TEXT_ACTOR'; payload: Actor['actorId'] }
  | { type: 'TOGGLE_MUTE_ACTOR'; payload: Actor['actorId'] };

export function actorReducer(prevState: ActorsInfo, action: ActorAction): ActorsInfo {
  switch (action.type) {
    case 'INITIALIZE_ACTORS': {
      const { payload } = action;
      return payload.reduce((actorsById, actor) => {
        actorsById[actor.actorId] = {
          actorId: actor.actorId,
          name: actor.name || actor.role,
          image: actor.image,
          hideText: false,
          mute: false,
        };

        return actorsById;
      }, {} as ActorsInfo);
    }
    case 'TOGGLE_TEXT_ACTOR': {
      const { payload: actorId } = action;

      const actor = prevState[actorId];
      if (!actor) return prevState;

      return { ...prevState, [actorId]: { ...actor, hideText: !actor.hideText } };
    }
    case 'TOGGLE_MUTE_ACTOR': {
      const { payload: actorId } = action;

      const actor = prevState[actorId];
      if (!actor) return prevState;

      return { ...prevState, [actorId]: { ...actor, mute: !actor.mute } };
    }
    default:
      throw new Error('unknown actorAction');
  }
}
